/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import { assert } from 'chai';
import {
    connect,
    createObjectId,
} from 'pow-mongodb-fixtures';
import mongodbURI from 'mongodb-uri';
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../archive-info', () => {
    const mongo = mongodbURI.parse(process.env.CLIO_MONGO_URL);
    const fixtures = connect(mongo.database, {
        host: mongo.hosts[0].host,
        port: mongo.hosts[0].port,
        user: mongo.username,
        pass: mongo.password,
    });
    const dataAPI = new DataAPI();
    const idOfCameraWithMjpgUrl = '123456789a123456789b1233';
    const idOfCameraWithRtspUrl = '123456789a123456789b1234';
    const badID = '123456789a123456789b1235';
    const index = 0;
    const badIndex = 1;
    const mjpgUrl = 'mjpg://url';
    const rtspUrl = 'rtsp://url';

    before(function before(done) {
        this.timeout(5000);
        fixtures.clearAndLoad({
            cameras: [{
                _id: createObjectId(idOfCameraWithMjpgUrl),
                streams: [{ mjpg_url: mjpgUrl }],
            }, {
                _id: createObjectId(idOfCameraWithRtspUrl),
                streams: [{ rtsp_url: rtspUrl }],
            }],
        }, (err) => {
            if (err) {
                throw new Error(err.message);
            }
            dataAPI.initialize({
                environment: 'unit-test',
                heartbeatInterval: 10,
                logLevel: 'DEBUG',
                mongoUrl: process.env.CLIO_MONGO_URL,
                port: 15925,
            });
            dataAPI.start(done);
        });
    });

    it('GET existing stream with MJPG URL should succeed', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${idOfCameraWithMjpgUrl}/streams/${index}/archive-info`)
            .expect(200)
            .expect((res) => {
                assert.deepEqual({
                    mjpgUrl,
                    audio: false,
                }, res.body);
            })
            .end(/** @type function */done);
    });

    it('GET existing stream with RTSP URL should succeed', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${idOfCameraWithRtspUrl}/streams/${index}/archive-info`)
            .expect(200)
            .expect((res) => {
                assert.deepEqual({
                    rtspUrl,
                    audio: false,
                }, res.body);
            })
            .end(/** @type function */done);
    });

    it('GET non-existing stream should fail', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${idOfCameraWithRtspUrl}/streams/${badIndex}/archive-info`)
            .expect(500)
            .end(/** @type function */done);
    });

    it('GET non-existing camera should fail', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${badID}/streams/${index}/archive-info`)
            .expect(500)
            .end(/** @type function */done);
    });

    after(done => dataAPI.stop(done));
});
